import $ from 'jquery';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
jQueryBridget('flickity', Flickity, $);

$('.js-gallery').each((index, gallery) => {
  const $gallery = $(gallery);
  const $galleryFlickity = $gallery.find('.js-gallery-flickity');

  $galleryFlickity.flickity({
    arrowShape: `M100 49.82c0-2.12-1.72-3.85-3.85-3.85H13.31l33.46-33.46a3.85 3.85 0 0 0-2.72-6.57c-.98 0-1.97.37-2.72 1.13L1.13 47.28a3.85 3.85 0 0 0 0 5.44l40.2 40.2a3.85 3.85 0 0 0 5.44 0 3.85 3.85 0 0 0 0-5.44L12.95 53.67h83.2c2.13 0 3.85-1.73 3.85-3.85z`,
    contain: true,
    draggable: true,
    pageDots: true,
    prevNextButtons: true,
    wrapAround: true,
  });
});
